import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { setPageMeta } from '../lib/seo';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [payment, setPayment] = useState(null);

  const orderId = searchParams.get('orderId');
  const paymentId = searchParams.get('paymentId');
  const MAX_ATTEMPTS = 30;

  const checkPaymentStatus = useCallback(async (attempt = 0) => {
    try {
      const endpoint = paymentId
        ? `/api/payments/status/${paymentId}`
        : `/api/payments/status-by-order/${orderId}`;
      const response = await axios.get(endpoint);
      const nextPayment = response.data;
      setPayment(nextPayment);

      if (!nextPayment) return;

      if (nextPayment.status === 'PENDING' || nextPayment.status === 'PROCESSING') {
        if (attempt < MAX_ATTEMPTS) {
          setTimeout(() => checkPaymentStatus(attempt + 1), 2000);
        }
        return;
      }

      if (['DECLINED', 'CANCELLED', 'REFUNDED'].includes(nextPayment.status)) {
        const errorQuery = paymentId
          ? `paymentId=${paymentId}${orderId ? `&orderId=${orderId}` : ''}`
          : `orderId=${orderId}`;
        navigate(`/payment/error?${errorQuery}`, { replace: true });
        return;
      }

      if (nextPayment.status === 'APPROVED') {
        const userData = localStorage.getItem('user');
        if (userData) {
          const user = JSON.parse(userData);
          user.credits = (parseFloat(user.credits) || 0) + parseFloat(nextPayment.amount);
          localStorage.setItem('user', JSON.stringify(user));
        }
      }
    } catch (error) {
      console.error('Failed to check payment status:', error);
    } finally {
      setLoading(false);
    }
  }, [navigate, orderId, paymentId]);

  useEffect(() => {
    if (orderId || paymentId) {
      checkPaymentStatus();
    } else {
      setLoading(false);
    }
  }, [orderId, paymentId, checkPaymentStatus]);

  useEffect(() => {
    setPageMeta({
      title: 'Payment Successful | Clouniq',
      description: 'Your payment has been processed successfully.',
    });
  }, []);

  return (
    <section className="payment-success-section xp-payment-result-page">
      <div className="container">
        <div className="payment-result-card">
          <div className="result-icon success">OK</div>
          <h2 className="result-title">Payment successful</h2>
          <p className="result-message">
            Your payment has been received and linked to your account.
          </p>

          {loading && (
            <div className="loading-spinner">
              <span>Verifying payment status...</span>
            </div>
          )}

          <div className="result-actions">
            {(payment?.status === 'PENDING' || payment?.status === 'PROCESSING') ? (
              <button className="btn btn-primary btn-lg" onClick={() => checkPaymentStatus(0)}>
                Check again
              </button>
            ) : (
              <Link to="/dashboard" className="btn btn-primary btn-lg">
                Go to dashboard
              </Link>
            )}
          </div>

          <div className="result-footer">
            Need help? <a href="/contact">Contact support</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PaymentSuccess;



